export const REQUIRED_FIELD_TEXT = "Field cannot be empty";
export const REQUIRED_FIELD_BOOLEAN = "Field must be selected";
